var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"prepend-icon":"mdi-minus","append-outer-icon":"mdi-plus","value":_vm.counter,"hide-details":""},on:{"click:prepend":_vm.sub,"click:append-outer":_vm.add}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }